import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">实时热门影视排行，大家都在看</p>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingData.map((item, idx) => (
              <a
                key={item.id}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}
                >
                  {item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 truncate">
                      {item.title}
                    </span>
                    <span className="text-[10px] text-foreground-400 bg-background-200/70 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.category}
                    </span>
                    {item.trend === 'new' && (
                      <span className="text-[10px] text-accent-600 bg-accent-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                </div>

                <span className="text-sm font-semibold text-primary-600 shrink-0 whitespace-nowrap">
                  {item.hot}
                </span>

                <span className="shrink-0">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-secondary-400 text-sm"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line text-accent-500 text-sm"></i>}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}